export enum BizCids {
  OpenOneClickPayModal = 'c_pay_r406hpao', // 极速支付-引导二次半页
  OneClickPayModal = 'c_pay_5fmudo92', // 极速支付-使用二次半页
  OneClickAdjustLimit = 'c_pay_6upj90jl', // 极速支付-独立调额
  OneClickAdJustLimitAndPayList = 'c_pay_p2l8y81b', // 极速支付-调整扣款顺序+调额
  OneClickPayAdjustPayList = 'c_pay_32hm96vg', // 极速支付-调整扣款顺序
  OneClickPayLoyalCustomerPage = 'c_pay_bueyms3u', // 极速支付-调额-免密授权
}

export enum OneClickPayModalBids {
  OpenOneClickPayModalSubmitBtnClick = 'b_pay_b3wza5ss_mc',
  OpenOneClickPayModalCancelBtnClick = 'b_pay_4lxqaa04_mc',
  OpenOneClickPayModalExit = 'b_pay_o7oy881j_mc',
  OneClickPayModalSubmitBtnClick = 'b_pay_tn6i8rn6_mc',
  OneClickPayModalCancelBtnClick = 'b_pay_5twfk21p_mc',
  OneClickPayModalAdjustLimitSubmitBtnClick = 'b_pay_m0xim3m3_mc', // 调整额度
  OneClickPayModalAdjustLimitCancelBtnClick = 'b_pay_q6l9gmvs_mc',
  OneClickPayModalAdjustDeduction = 'b_pay_rg05vqb1_mc', // 点击调整扣款顺序
  OneClickPayModalDeductionIsAdjusted = 'b_pay_n8r6nbt7_mc', // 扣款顺序被调整
  OneClickPayModalModuleShow = 'b_pay_z02zvz5i_mv', // 引导调整扣款顺序 + 营销展示模块
  OneClickPayModalAdjustPayList = 'b_pay_3i4cjz9j_mc', // 引导调整扣款顺序模块立即调整按钮点击
  OneClickPayModalAdjustPayListAndLimit = 'b_pay_ma5vbejk_mc', // 调整扣款顺序 + 额度，立即调整按钮点击
  OneClickPayModalAdjustPayListAndLimitView = 'b_pay_ma5vbejk_mv', // 调整扣款顺序 + 额度，营销/引导区展示
  OneClickPayModalAdjustPayListClick = 'b_pay_e7lrlhwi_mc', // 调整扣款顺序，立即调整模块点击
  OneClickPayModalAdjustPayListView = 'b_pay_e7lrlhwi_mv', // 调整扣款顺序，立即调整模块展示
  OneClickPayModalAdjustPayListConfirmClick = 'b_pay_vwmitofv_mc', // 调整扣款顺序，上/下按钮点击
  OneClickPayModalAdjustPayListCloseClick = 'b_pay_zn4d5e82_mc', // 调整扣款顺序，关闭按钮点击
  OneClickPayModalAutoPay = 'b_pay_6qu9jh2q_mc', // 已开通页面，倒计时后支付点击
  OneClickPayModalChangePaymentClick = 'b_pay_dj8s9355_mc', // 更换支付方式点击
  OneClickPayModalCloseModalClick = 'b_pay_cqnrnduc_mc', // 关闭弹窗点击
  OneClickPayModalSwitchMethodClick = 'b_pay_aydcrhr6_mc', // 切换支付方式点击
  OneClickPayModalQuotaAdjustment = 'b_pay_xm3dh0lf_mv', // 调额信息模块
  OneClickPayModalPayWithoutPasswordView = 'b_pay_vjwo4q0p_mv', // 付款免密模块曝光
  OneClickPayModalPayWithoutPasswordClick = 'b_pay_vjwo4q0p_mc', // 付款免密模块点击
  OneClickPayModalPaymentPriorityView = 'b_pay_quzp6qdc_mv', // 扣款顺序模块曝光
  OneClickPayModalVerifyAndSubmitView = 'b_pay_388ggk0p_mv', // 验证通过提交曝光
  OneClickPayModalGuideModuleExpose = 'b_pay_fcretkxe_mv', // 高优引导区域曝光
  OneClickPayModalGuideModuleClick = 'b_pay_fcretkxe_mc', // 高优引导区域点击
}

/** 高优引导模块 - 自定义指标（reportMetric） */
export enum GuideModuleMetricKeys {
  /** 高优引导区域曝光 */
  GuideExpose = 'oneclick_pay_guide_module_expose',
  /** 高优引导区域点击 */
  GuideClick = 'oneclick_pay_guide_module_click',
  /** 实验组样式参数缺失告警 */
  StyleMissing = 'oneclick_pay_guide_style_missing',
}

export enum OpenOneClickBids {
  OpenOneClickPaySuccess = 'b_pay_55gi7hct_mv',
  StartVerify = 'b_pay_xweunckr_mv',
  VerifySuccess = 'b_pay_65byxvtm_mv',
  VerifyCancel = 'b_pay_42lnp2n7_mv',
  VerifyFail = 'b_pay_hf7dmuar_mv',
  VerifyResult = 'b_pay_ykvr08cy_mc',
}
export const CidMap: {
  [key: string]: {
    adjustPayListLxBid: string;
    adjustPayListUtmSource: string;
    guideAndPromoModuleLxBid: string;
  };
} = {
  [BizCids.OpenOneClickPayModal]: {
    adjustPayListLxBid: OneClickPayModalBids.OneClickPayModalAdjustPayList,
    adjustPayListUtmSource: 'Oneclickpay_open',
    guideAndPromoModuleLxBid: OneClickPayModalBids.OneClickPayModalModuleShow,
  },
  [BizCids.OneClickPayModal]: {
    adjustPayListLxBid: OneClickPayModalBids.OneClickPayModalAdjustPayList,
    adjustPayListUtmSource: 'Oneclickpay_open',
    guideAndPromoModuleLxBid: OneClickPayModalBids.OneClickPayModalModuleShow,
  },
  [BizCids.OneClickAdJustLimitAndPayList]: {
    adjustPayListLxBid:
      OneClickPayModalBids.OneClickPayModalAdjustPayListAndLimit,
    adjustPayListUtmSource: 'Oneclickpay_adjust_sequence_limitation',
    guideAndPromoModuleLxBid:
      OneClickPayModalBids.OneClickPayModalAdjustPayListView,
  },
  [BizCids.OneClickPayAdjustPayList]: {
    adjustPayListLxBid: OneClickPayModalBids.OneClickPayModalAdjustPayListClick,
    adjustPayListUtmSource: 'Oneclickpay_adjust_sequence',
    guideAndPromoModuleLxBid:
      OneClickPayModalBids.OneClickPayModalAdjustPayListView,
  },
  [BizCids.OneClickPayLoyalCustomerPage]: {
    adjustPayListLxBid: OneClickPayModalBids.OneClickPayModalChangePaymentClick,
    adjustPayListUtmSource: 'Oneclickpay_loyal_customer',
    guideAndPromoModuleLxBid:
      OneClickPayModalBids.OneClickPayModalQuotaAdjustment,
  },
};
